/**
 *
 */
class BecomeClientForm{

    /**
     *
     * @param options
     */
    constructor(options) {
        console.debug('BecomeClientForm : Construct', options);
        this.options = options;
        this.renderView();
    }



    /**
     *
     * @returns {{}}
     */
    renderView(){

        let _self = this;

        let app = new Vue({

            el: _self.options.container,

            // --------------------------------------------------------------------------------------------------------- DATAS
            data() {
                return {
                    isFinancial: false,
                    excessOnMillion: true,
                    residencyCountryChoices: _self.options.datas.residencyCountry,
                    circumstancesChangeChoices: _self.options.datas.circumstancesChange,
                    descriptionOfYouChoices: _self.options.datas.descriptionOfYou,
                    interestCenterChoices: _self.options.datas.interestCenter,
                    residencyCountry: '',
                    circumstancesChange: '',
                    descriptionOfYou: '',
                    interestCenter: [],
                    showHelp: false
                }
            },

            computed: {

                displayNext: function() {

                    if (this.isFinancial) {
                        if( this.descriptionOfYou === '' || this.interestCenter.length === 0){
                            return false;
                        }
                    } else {
                        if(this.residencyCountry === ''){
                            return false;
                        }
                        if (!this.excessOnMillion && this.circumstancesChange === '') {
                            return false;
                        }
                    }
                    return true;
                }
            },


            // --------------------------------------------------------------------------------------------------------- LIFECYCLE
            mounted() {
                console.debug('BecomeClientForm : Mounted', _self);
            },

            updated(){
            },

            // --------------------------------------------------------------------------------------------------------- METHODS
            methods:{
                goNext: function(){

                    this.showHelp = false;

                    if(this.displayNext){
                        // l'utilisateur est un financier
                        if(this.isFinancial){
                            this.switchUrl(_self.options.linkFinancial);
                            return;
                        }
                        // l'utilisateur est un privéee qui a de la caillase ou va en avoir
                        if (!this.isFinancial && this.circumstancesChange !== "No – I do not expect my circumstances to change") {
                            this.switchUrl(_self.options.linkPrivateClient);
                            return;
                        }
                        // l'utilisateur ne nous interresse pas
                        this.switchUrl(_self.options.linkSorry);
                    } else {
                        this.showHelp = true;
                    }

                },
                switchUrl(url){
                    // console.error('====> goto ' + url);
                    let datasToSave = {};
                    if(this.isFinancial) {
                        datasToSave = {
                            'descriptionOfYou': this.descriptionOfYou,
                            'interestCenter': this.interestCenter,
                        };
                    } else {
                        datasToSave = {
                            'residencyCountry': this.residencyCountry,
                            'circumstancesChange': this.circumstancesChange,
                        };
                    }
                    // console.debug(datasToSave);
                    localStorage.setItem('becomeClient', JSON.stringify(datasToSave));
                    document.location.href = url;
                }
            },


        });
    }

}
